import { render, staticRenderFns } from "./employeesList.vue?vue&type=template&id=04b13320&"
import script from "./employeesList.vue?vue&type=script&lang=js&"
export * from "./employeesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports